// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { logout } from '../../helios/services/authService';

/**
 * Ends the session and sends the browser to CIAM's sign-out, back to /login.
 *
 * The facade Admin Center uses to sign out, so it never imports Helios'
 * `services/authService` directly (ADR-0014). Same call as the Energy Fluo
 * header's Log out.
 */
export function signOut(): Promise<void> {
  return logout();
}
